// extracted by mini-css-extract-plugin
module.exports = {"back-button":"BackButton-module__back-button___12L0H"};